// noinspection JSNonASCIINames,NonAsciiCharacters

export const currencyTranslations = {
    currency: {
        commonUsedGroup: "Commonly used",
        otherGroup: "Other",
        "EUR": "Euro",
        "USD": "US Dollar",
        "GBP": "British Pound",
        "PLN": "Polish Zloty",
        "SEK": "Swedish Krona",
        "NOK": "Norwegian Krone",
        "CZK": "Czech Koruna",
        "PHP": "Philippine Peso",
        "UAH": "Ukrainian Hryvnia",
        "ISK": "Icelandic Krona",
        "CAD": "Canadian Dollar",
        "CHF": "Swiss Franc",
        "AUD": "Australian Dollar",
        "RUB": "Russian Ruble",
        "VND": "Vietnamese Dong",
        "INR": "Indian Rupee",
        "CNY": "Chinese Yuan",
        "HUF": "Hungarian Forint",
        "RON": "Romanian Leu",
    }
}